/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CancelTicketRequest as ClientSupportApiContractCourtesyCancelTicketRequest } from '../models/ClientSupportApi/Contract/Courtesy/cancel-ticket-request';

@Injectable({
  providedIn: 'root',
})
export class CourtesyService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiSupportCancelTicketPost
   */
  static readonly ApiSupportCancelTicketPostPath = '/api/Support/CancelTicket';

  /**
   * Cancel (spoil) prepaid ticket.
   *
   * ### Claim
   *  boservice.support.cancelticket
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSupportCancelTicketPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSupportCancelTicketPost$Response(params?: {

    /**
     * *	language code
     */
    lang?: string;
    body?: ClientSupportApiContractCourtesyCancelTicketRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, CourtesyService.ApiSupportCancelTicketPostPath, 'post');
    if (params) {
      rb.query('lang', params.lang, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Cancel (spoil) prepaid ticket.
   *
   * ### Claim
   *  boservice.support.cancelticket
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSupportCancelTicketPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSupportCancelTicketPost(params?: {

    /**
     * *	language code
     */
    lang?: string;
    body?: ClientSupportApiContractCourtesyCancelTicketRequest
  },
  context?: HttpContext

): Observable<void> {

    return this.apiSupportCancelTicketPost$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
